angular.module('unergie.main')
.directive('invoices', ($filter, $timeout, DataAccessInvoices, BoFeaturesService, ErrorCatcher, ApiBilling, ContractService, StatusRenderer, DataAccessSearch,
    DownloadService, PaymentService, AlertManager, NgTableParams) =>
    ({
        restrict: 'E',
        templateUrl: '/directives/invoices/invoices.html',
        scope: {
            onInvoicesChanged: '&',
        },
        link($scope) {
            $scope.canSeeInvoices = BoFeaturesService.isFeatureOn('canSeeInvoicesPage')
            $scope.canRunSimuToCheckInvoices = BoFeaturesService.isFeatureOn('canRunSimuToCheckInvoices')
            $scope.canDownloadInvoice = BoFeaturesService.isFeatureOn('canDownloadInvoice')
            $scope.canSendInvoice = BoFeaturesService.isFeatureOn('canSendInvoice')

            $scope.billingAdmin = BoFeaturesService.isFeatureOn('billingAdmin')

            $scope.isMisc = (i) => i.type.includes('MISC')
            $scope.isReversal = (i) => i.type.includes('_REVERSAL')
            $scope.reversable = (invoice) => [50, 54, 55, 93, 96].includes(invoice.status) && !$scope.isReversal(invoice)

            $scope.getSimplePaymentStatus = PaymentService.getSimplePaymentStatus

            $scope.paymentValidated = (payment) => !PaymentService.paymentNotYetValidated(payment)

            $scope.statusRenderer = StatusRenderer
            $scope.invoices = []
            $scope.tableParamsInvoices = undefined

            $scope.TC = {
                BASE: 'Base',
                HP: 'Heures pleines',
                HC: 'Heures creuses',
            }

            const maxDaysSinceSimulation = BoFeaturesService.get('maxDaysSinceSimulation')

            const formatNature = (nature) => {
                switch (nature) {
                    case 'AUTO-RELEVE':
                    case 'ARLV':
                        return 'réelles client'
                    case 'REEL':
                    case 'TRLV':
                        return 'réelles Enedis'
                    case 'FAC-REDRESS':
                    case 'ANNULATION':
                    case 'CSIF':
                    case 'CAIF':
                    case 'RES':
                    case 'ESTI':
                    case 'ESTIME':
                    default:
                        return 'estimé'
                }
            }

            const classFromNature = (nature) => {
                if (nature.includes('réelles client')) {
                    return 'blue'
                } else if (nature.includes('réelles Enedis')) {
                    return 'green'
                } else if (nature.includes('estimé')) {
                    return 'orange'
                }
                return 'red'
            }

            const load = (contract) => {
                $scope.contract = contract

                return DataAccessInvoices.getInvoices({ id_contract: contract.id }).$promise
                .then((invoices) => {
                    $scope.invoices = invoices
                    $scope.tableParamsInvoices = new NgTableParams({ sorting: { payment_date: 'desc' } }, { dataset: $scope.invoices })

                    $scope.onInvoicesChanged({ invoices: $scope.invoices })
                })
            }

            $scope.dlInvoice = (invoice, e) => {
                e.preventDefault()
                e.stopPropagation()
                DownloadService.downloadInvoice(invoice.download_link, $scope.contract.id_account)
            }

            $scope.resendInvoiceEmail = (invoice) => {
                invoice.sendingEmail = true
                DataAccessInvoices.resendEmail({ id_invoice: invoice.id }, { id_account: $scope.contract.id_account }).$promise
                .then((result) => AlertManager.success('Email envoyé'))
                .catch(ErrorCatcher)
                .finally(() => {
                    invoice.sendingEmail = false
                })
            }


            $scope.filterLabel = (label) => _.defaultTo(label, '').replace('PRÉLÈVEMENT ', '').replace('PLÜM ÉNERGIE ', '')

            ContractService.watch('invoices', load)

            $scope.run = (invoice) => {
                if (invoice.processing) {
                    return
                }
                invoice.processing = true
                return ApiBilling.runInvoice({ id_invoice: invoice.id, send: true }, {}).$promise.then(() => {
                    AlertManager.success('Facture débloquée')
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    invoice.processing = false
                    load({ id: $scope.contract.id })
                })
            }

            $scope.unlockInvoice = (invoice) => {
                if (invoice.processing) {
                    return
                }
                invoice.processing = true
                return Promise.resolve().then(() => { // re-simulate if last simulation is too old
                    if ((invoice.billing_context.computation_date && moment().diff(invoice.billing_context.computation_date, 'days') > maxDaysSinceSimulation)) {
                        return ApiBilling.simulateTimetable({ id_invoice: invoice.id }, {}).$promise.then(() => {
                            return ApiBilling.prepareInvoice({ id_invoice: invoice.id }, {}).$promise
                        }).then(() => AlertManager.success('La facture bill shock était trop ancienne et a du être rééditée, son montant a donc pu être modifié.'))
                    }
                })
                .then(() => ApiBilling.regenTimetable({ id_invoice: invoice.id }, {}).$promise)
                .then(() => AlertManager.success('Facture débloquée, lancement en cours, veuillez rafraichir.'))
                .catch(ErrorCatcher)
                .finally(() => {
                    invoice.processing = false
                    load({ id: $scope.contract.id })
                })
            }

            $scope.reverseInvoice = (invoice) => {
                if (invoice.processing) {
                    return
                }
                invoice.processing = true
                invoice.reversing = true
                return ApiBilling.reverseInvoice({ id_invoice: invoice.id }, {}).$promise.then((result) => {
                    AlertManager.success('Reversement OK')
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    invoice.processing = false
                    invoice.reversing = false
                    load({ id: $scope.contract.id })
                })
            }

            $scope.refreshInvoiceReadings = (invoice) => {
                if (!invoice.reading_ids) {
                    return
                }
                return DataAccessSearch({
                    in: [`id=${invoice.reading_ids.ids.join(',')}`],
                    orderBy: '-end_date',
                    columns: ['start_date', 'end_date', 'last_index_nature', 'index_nature', 'last_value', 'value', 'temp_class'],
                })
                .searchPaginated({ resource: 'readings', class: 'F' }).$promise.then((readingsResult) => {
                    const readingsGrouped = _.groupBy(_.filter(_.orderBy(readingsResult.results, 'end_date'), (r) => r.start_date !== null), 'start_date')
                    const dates = Object.keys(readingsGrouped).sort()
                    invoice.startingIndex = _.reduce(readingsGrouped[dates[0]], (acc, reading) => {
                        acc.nature = formatNature(reading.last_index_nature)
                        acc.style = classFromNature(acc.nature)
                        acc[reading.temp_class] = reading.last_value
                        return acc
                    }, {})
                    invoice.endIndex = _.reduce(readingsGrouped[dates.pop()], (acc, reading) => {
                        acc.nature = formatNature(reading.index_nature)
                        acc.style = classFromNature(acc.nature)
                        acc[reading.temp_class] = reading.value
                        return acc
                    }, {})
                }).catch(ErrorCatcher)
            }

            $scope.toggleExpand = function (invoice) {
                let p = Promise.resolve()
                if (!invoice.type.includes('MISC') && !invoice.fetched) {
                    invoice.refreshing = true
                    p = $scope.refreshInvoiceReadings(invoice)
                }
                p.then(() => {
                    $timeout(() => {
                        invoice.fetched = true
                        invoice.refreshing = false
                        invoice.expanded = !invoice.expanded
                    })
                })
            }
        },
    })
)
